import React from "react";
import Svg from "../Svg";
import { SvgProps } from "../types";

const Icon: React.FC<SvgProps> = ({...props}) => {
  return (
    <Svg width="40" height="40" viewBox="0 0 74 74" fill="none" {...props}>
        <g clipPath="url(#clip0_2331_10333)">
        <circle cx="37" cy="37" r="37" fill="#0090FD"/>
        <g clipPath="url(#clip1_2331_10333)">
        <path fillRule="evenodd" clipRule="evenodd" d="M32.0136 29.2483H42.317L38.3564 48.721L38.158 50.1522C38.158 50.859 38.5479 51.2215 39.327 51.2215C40.0991 51.1838 40.8809 50.9315 41.6593 50.4697L40.8005 54.616C39.4047 55.4954 37.7674 55.9572 35.8701 55.9949C32.8877 56.1022 31.3025 54.6261 31.0943 51.5913C31.0943 50.8148 31.2158 49.8151 31.4482 48.6116L34.3459 34.3393H31L32.0136 29.2491V29.2483ZM44 21.232C43.9667 22.5457 43.4714 23.6789 42.5279 24.6294C41.5379 25.5537 40.4286 26.0243 39.1716 26.0605C37.2402 25.9518 36.2079 24.8925 36.0782 22.8821C36.1385 21.5322 36.6325 20.3997 37.551 19.4855C38.4959 18.5619 39.5975 18.0623 40.8449 18C42.8123 18.1348 43.8613 19.2136 44 21.232Z" fill="white"/>
        </g>
        </g>
        <defs>
        <clipPath id="clip0_2331_10333">
        <rect width="74" height="74" fill="white"/>
        </clipPath>
        <clipPath id="clip1_2331_10333">
        <rect width="13" height="38" fill="white" transform="translate(31 18)"/>
        </clipPath>
        </defs>
    </Svg>
  );
};

export default Icon;
